var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-previous-next-buttons',{attrs:{"on-previous-report":_vm.handlePreviousClick,"previous-disabled":_vm.previousDisabled,"on-next-report":_vm.handleNextClick,"next-disabled":_vm.nextDisabled,"data-automation-id":"wrapper_report_nav"}})}
var staticRenderFns = []

export { render, staticRenderFns }